module.exports = __webpack_public_path__ + "static/storage-c287a8ab33416a72dc119ed86565a4e8.jpg";